import { RemitClaim } from '@/types/billing';
import { Cms1500 } from '@/types/encounter';

export const ClaimStatus = {
  PENDING_RESPONSE_FROM_PAYER: 'pending response from payer',
  DENIED_BY_INSURANCE: 'denied by insurance',
  PATIENT_RESPONSIBILITY: 'patient responsibility',
  PARTIALLY_PAID: 'partially paid',
  FULLY_PAID: 'fully paid',
  NOT_SENT: 'not sent',
  UNKNOWN: 'unknown',
  OVER_PAYMENT: 'over payment'
} as const;

export function computeClaimStatus(
  remitClaim: RemitClaim | undefined,
  cms1500: Cms1500,
  isMostRecent = false
) {
  const { paid_amount_in_cents, charge_amount_in_cents, patient_responsibility_amount_in_cents } =
    remitClaim || {};
  const last_sent_to_clearinghouse_at = cms1500.last_sent_to_clearinghouse_at;
  const lastRemitPaidAmount = paid_amount_in_cents;
  const lastRemitChargeAmount = charge_amount_in_cents || 0;
  const lastRemitPatientResponsibility = patient_responsibility_amount_in_cents || 0;
  const lastPaidAt = remitClaim?.financial_info?.paid_at
    ? new Date(remitClaim?.financial_info?.paid_at)
    : null;

  let status: (typeof ClaimStatus)[keyof typeof ClaimStatus] = ClaimStatus.UNKNOWN;
  if (
    (!lastPaidAt && last_sent_to_clearinghouse_at && isMostRecent) ||
    (lastPaidAt &&
      last_sent_to_clearinghouse_at &&
      new Date(last_sent_to_clearinghouse_at) > lastPaidAt &&
      isMostRecent)
  ) {
    status = ClaimStatus.PENDING_RESPONSE_FROM_PAYER;
  } else if (lastRemitPaidAmount === 0 && last_sent_to_clearinghouse_at) {
    status = ClaimStatus.DENIED_BY_INSURANCE;
  } else if ((lastRemitPatientResponsibility || 0) > 0) {
    status = ClaimStatus.PATIENT_RESPONSIBILITY;
  } else if (lastRemitPaidAmount && (lastRemitPaidAmount || 0) < (lastRemitChargeAmount || 0)) {
    status = ClaimStatus.PARTIALLY_PAID;
  } else if (
    lastRemitPaidAmount &&
    lastRemitPaidAmount > 0 &&
    (lastRemitPaidAmount || 0) === (lastRemitChargeAmount || 0)
  ) {
    status = ClaimStatus.FULLY_PAID;
  } else if (
    lastRemitPaidAmount &&
    lastRemitPaidAmount > 0 &&
    (lastRemitPaidAmount || 0) > (lastRemitChargeAmount || 0)
  ) {
    status = ClaimStatus.OVER_PAYMENT;
  } else if (!last_sent_to_clearinghouse_at) {
    status = ClaimStatus.NOT_SENT;
  }

  return { status, lastRemitChargeAmount, lastRemitPaidAmount, lastRemitPatientResponsibility };
}
